module.exports = __webpack_public_path__ + "img/home_banner_3.ab47bd07.png";